<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Strong>Note : If any data is not available or applicable, kindly mention NA </Strong></br>
    <Strong v-if="this.is_unicode_note == 'true' || this.is_unicode_note == true">टीप : कोणतीही माहिती उपलब्ध नसल्यास किंवा लागू नसल्यास, कृपया NA नमूद करा.</Strong>
    <v-form
      id="transport_details_form"
      @submit.prevent="submit"
      v-model="isValid"
      v-if="loader"
    >
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input
            type="hidden"
            :value="application_form_data.admission_form_id"
            name="admission_form_id"
          /> </v-col
      ></v-row>
      <v-row dense justify="center" v-if="is_transport_facility_needed != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="is_transport_facility_needed.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="is_transport_facility_needed.field_value"
            :items="is_transport_facility_needed.options"
            :name="is_transport_facility_needed.field_name"
            :required="is_transport_facility_needed.required"
            :rules="
              is_transport_facility_needed.required
                ? [
                    v =>
                      !!v ||
                      is_transport_facility_needed.field_display_name +
                        ' is required'
                  ]
                : []
            "
            :clearable="is_transport_facility_needed.required ? false : true"
            :hint= is_transport_facility_needed.field_display_name
            persistent-hint
            single-line
            prepend-icon="mdi-account-question"
            outlined
          ></v-autocomplete> </v-col
      ></v-row>
      <span v-if="is_transport_facility_needed.field_value == 'Yes'">
      <v-row dense justify="center" v-if="transport_resedential_address != null">
        <v-col cols="10" sm="10" md="10">
          <!-- <v-icon color="error">*</v-icon>/ -->
           <v-icon color="error" v-if="transport_resedential_address.required">*</v-icon>
          <v-textarea
            dense
            v-model="transport_resedential_address.field_value"
            :name="transport_resedential_address.field_name"
            :clearable="transport_resedential_address.required ? false : true"
            :prepend-icon="
              transport_resedential_address.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            "
            outlined
            readonly
            :hint= transport_resedential_address.field_display_name
            persistent-hint
          ></v-textarea> </v-col
      ></v-row>

       <v-row dense justify="center" v-if="transport_boarding_point != null && tenant == 'sbpps'" >
      <p>Please click on the following link for transport routes : </p>
      <p> <a target="_blank" href="https://drive.google.com/file/d/1U7jBqzT7tw4JblKV2XlrbJMURHkcSzYv/view?usp=sharing">https://drive.google.com/file/d/1U7jBqzT7tw4JblKV2XlrbJMURHkcSzYv/view?usp=sharing</a></p>
 </v-row>

       <v-row dense justify="center" v-if="transport_boarding_point != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field
            dense
            v-model.trim="transport_boarding_point.field_value"
            :name="transport_boarding_point.field_name"
            :required="true"
            :rules="
              true
                ? [v => !!v || transport_boarding_point.field_display_name + ' is required']
                : []
            "
            :clearable="transport_boarding_point.required ? false : true"
            :prepend-icon="
              transport_boarding_point.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            "
            outlined
            :hint= transport_boarding_point.field_display_name
            persistent-hint
          ></v-text-field> </v-col
      ></v-row>

      <v-row dense justify="center" v-if="transport_drop_point != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field
            dense
            v-model.trim="transport_drop_point.field_value"
            :name="transport_drop_point.field_name"
            :required="true"
            :rules="
              true
                ? [v => !!v || transport_drop_point.field_display_name + ' is required']
                : []
            "
            :clearable="transport_drop_point.required ? false : true"
            :prepend-icon="
              transport_drop_point.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
            "
            outlined
            :hint= transport_drop_point.field_display_name
            persistent-hint
          ></v-text-field> </v-col
      ></v-row>

      <v-row dense justify="center" v-if="transport_route != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="transport_route.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="transport_route.field_value"
            :items="transport_route.options"
            item-text ="name"
            item-value ="id"
            :name="transport_route.field_name"
            :required="transport_route.required"
            :rules="
              transport_route.required
                ? [
                    v =>
                      !!v ||
                      transport_route.field_display_name +
                        ' is required'
                  ]
                : []
            "
            :clearable="transport_route.required ? false : true"
            :hint= transport_route.field_display_name
            persistent-hint
            single-line
            prepend-icon="mdi-road"
            outlined
          ></v-autocomplete> </v-col
      ></v-row>
      <v-row dense justify="center" v-if="transport_bus_number != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="transport_bus_number.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="transport_bus_number.field_value"
            :items="transport_bus_number.options"
            item-text ="name"
            item-value ="id"
            :name="transport_bus_number.field_name"
            :required="transport_bus_number.required"
            :rules="
              transport_bus_number.required
                ? [
                    v =>
                      !!v ||
                      transport_bus_number.field_display_name +
                        ' is required'
                  ]
                : []
            "
            :clearable="transport_bus_number.required ? false : true"
            :hint= transport_bus_number.field_display_name
            persistent-hint
            single-line
            prepend-icon="mdi-bus"
            outlined
          ></v-autocomplete> </v-col
      ></v-row>

      
      <!-- <v-row dense justify="center" v-if="transport_declaration != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="transport_declaration.required">*</v-icon>
          <v-autocomplete
            dense
            v-model="transport_declaration.field_value"
            :items="transport_declaration.options"
            :name="transport_declaration.field_name"
            :required="transport_declaration.required"
            :rules="
              transport_declaration.required
                ? [
                    v =>
                      !!v ||
                      transport_declaration.field_display_name +
                        ' is required'
                  ]
                : []
            "
            :clearable="transport_declaration.required ? false : true"
            :hint= transport_declaration.field_display_name
            persistent-hint
            single-line
            prepend-icon="mdi-account-question"
            outlined
          ></v-autocomplete> </v-col
      ></v-row> -->
      </span>

         <v-row
        dense
        justify="center"
        v-if="defaultValues!='' && is_transport_facility_needed.field_value == 'Yes'"
      >
      <span v-html="defaultValues"></span>
         </v-row>

        <v-row
        dense
        justify="center"
        v-if="is_transport_facility_needed.field_value == 'Yes'"
      >
        <v-col cols="10" sm="10" md="10">
          <v-checkbox
            v-model.trim="transport_declaration.field_value"
            :name=transport_declaration.field_name
            :value=transport_declaration.field_value
            color="primary darken-1"
            label="I hereby verify that I have read, understood and accepted the statements above"
            :rules="
              transport_declaration.required
                ? [
                    v =>
                      !!v ||
                      transport_declaration.field_display_name +
                        ' is required'
                  ]
                : []
            "
          ></v-checkbox>
        </v-col>
      </v-row>

      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10">
          <div style="text-align:center">
            <v-btn
              class="mt-2"
              :color="isValid ? 'primary darken-1' : 'grey lighten-1'"
              @click="submit"
              :disabled="!isValid"
              >Save</v-btn
            >
          </div>
        </v-col></v-row
      >
    </v-form>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      tenant: "",
      isValid: true,
      loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      application_form_data: {
        admission_form_no: "",
        admission_form_id: "",
        display_admission_form_no: ""
      },
      transport_resedential_address: {},
      transport_boarding_point: {},
      transport_drop_point: {},
      transport_route: {},
      transport_bus_number: {},
      is_transport_facility_needed: {},
      transport_declaration: {},
      defaultValues:{},
      is_unicode_note: ""
    };
  },
  methods: {
    checkdeclarations(){
        if(this.is_transport_facility_needed.field_value == 'Yes' && !this.transport_declaration){
            this.isValid=false
        }
        else if(this.is_transport_facility_needed.field_value == 'Yes' && this.transport_declaration){
            this.isValid=true
        }
        else if(this.is_transport_facility_needed.field_value == 'No'){
                this.isValid=true
        }
    },
    submit: function(e) {
      if(this.is_transport_facility_needed.field_value == 'Yes'){
        if ((this.transport_bus_number != null && this.transport_bus_number.field_value == null && this.transport_bus_number.required) || (this.transport_route != null && this.transport_route.field_value == null && this.transport_route.required)) {
          this.showSnackbar(
            "red",
            'Please enter all the required data'
          );
          return;
        }
      }
      this.loader = false;
      var form = document.getElementById("transport_details_form");
      var formData = new FormData(form);
      if(this.transport_bus_number != null){
        formData.set(
          "transport_bus_number",
          this.transport_bus_number.field_value
        );
      }
      if(this.transport_route != null){
        formData.set(
          "transport_route",
          this.transport_route.field_value
        );
      }
      //formData.append("transport_declaration",this.transport_declaration)
      axios.post("/admissionForm/saveTransportDetails", formData)
      .then(
        response => {
          // success callback
          // this.form_progress = response.data.form_progress
          if (response.data.form_saved == "YES") {
            this.loader = true;
            this.showSnackbar(
              "#4caf50",
              'Saved Successfully...Click on Next Tab To Continue'
            ); // show snackbar on success
          }
          else{
            this.loader = true;
            this.showSnackbar(
              "red",
              response.data.snackbar
            ); // show snackbar on success
            return
          }
          this.$store.commit("setform_progress", response.data.form_progress);
        },
        response => {
          // error callback
        }
      )
      .catch((error) =>{
        console.log(error)
        this.loader = true;
            this.showSnackbar(
              "red",
              'something went wrong!!!'
            ); // show snackbar on success
      });
    },
    getform() {
      axios
        .post("/admissionForm/transportDetails", this.application_form_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.loader = true;
            this.transport_resedential_address = res.data.transport_resedential_address;
            this.transport_boarding_point = res.data.transport_boarding_point;
            this.transport_drop_point = res.data.transport_drop_point;
            this.is_transport_facility_needed = res.data.is_transport_facility_needed;
            this.transport_declaration = res.data.transport_declaration;
            this.transport_route = res.data.transport_route;
            this.transport_bus_number = res.data.transport_bus_number;
            this.defaultValues = res.data.defaultValues;
            this.$store.commit("setform_progress", res.data.form_progress);
            //this.form_progress = res.data.form_progress
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    }
  },
  mounted() {
    this.is_unicode_note = localStorage.getItem("is_unicode_note");
    this.application_form_data = this.$store.getters.application_form_data;
    this.getform();
  },
  created() {
            this.tenant = localStorage.getItem("EPS-tenant");
        },
  watch: {
    date(val) {
      this.date_of_birth.field_value = this.formatDate(this.date);
    }
  },
  
};
</script>
